import React from 'react'
import PlainModal from '../PlainModal'
import styles from './GenericModals.module.scss'

export const EmptyDayModal: React.FC<{
  open: boolean;
  canShowInsta?: boolean;
  onClose: () => void;
  onSetEditInsta?: () => void;
}>
  = ({ open, canShowInsta, onClose, onSetEditInsta }) => (
  <PlainModal isOpen={open} onClose={onClose} size="xs" ariaLabel="View Available Shifts" dataTestId="empty-day-modal">
    <div className={styles.dialog}>
      <h2 className={styles.title}>View Available Shifts</h2>
      <div className={styles.centerText}>
        To get started, tap "View All Shifts" or a green calendar date.
      </div>
      <div className={styles.actions}>
        {canShowInsta ? (
          <button
            type="button"
            className={styles.outlinedButton}
            onClick={onSetEditInsta}
            aria-label="Set/edit auto-book schedule"
            data-testid="empty-day-set-edit-autobook"
          >
            Set/edit auto-book schedule
          </button>
        ) : null}
        <button
          type="button"
          className={styles.primaryButton}
          onClick={onClose}
          aria-label="OK"
          data-testid="empty-day-ok"
        >
          OK
        </button>
      </div>
    </div>
  </PlainModal>
)

export const ManualShiftCongratsModal: React.FC<{
  open: boolean;
  onContinue: () => void;
  onCancel: () => void;
}>
  = ({ open, onContinue, onCancel }) => (
  <PlainModal isOpen={open} onClose={onCancel} size="xs" ariaLabel="Congrats on Reporting/Booking a Shift" dataTestId="manual-shift-congrats-modal">
    <div className={styles.dialog}>
      <h2 className={styles.title}>Congrats on
        <br/>Reporting/Booking a Shift!</h2>
      <div className={styles.bodyText}>
        Many of our members make lasting connections and are asked to come back for more shifts.
        <br/><br/>
        Just be sure to follow our policy for direct bookings by using this feature to book or record any shift you directly arrange with any TempStars office.
        <br/><br/>
        It is policy and it also allows you to easily create and track your schedule and invoices for your shifts.
        <br/>
        <a href="#" onClick={(e) => { e.preventDefault(); const url = 'https://support.tempstars.com/hc/en-us/articles/1500008821802-Report-Book-A-Shift-'; try { if ((window as any).Cordova) { (window as any).cordova.InAppBrowser.open(url, '_system', 'location=yes'); } else { window.open(url, '_blank', 'location=yes'); } } catch {} }}>Click here to learn more!</a>
      </div>
      <div className={styles.stackedActions}>
        <button type="button" className={styles.primaryButton} onClick={onContinue} aria-label="Continue" data-testid="manual-shift-continue">Continue</button>
        <button type="button" className={styles.textButton} onClick={onCancel} aria-label="Cancel" data-testid="manual-shift-cancel">Cancel</button>
      </div>
    </div>
  </PlainModal>
)

export const ManualShiftInfoModal: React.FC<{ open: boolean; onClose: () => void }>
  = ({ open, onClose }) => (
  <PlainModal isOpen={open} onClose={onClose} size="xs" ariaLabel="Report/Book a Shift" dataTestId="manual-shift-info-modal">
    <div className={styles.dialog}>
      <h2 className={styles.title}>Report/Book a Shift</h2>
      <div className={styles.bodyText}>
        Use this feature to keep track of all your shifts that you directly arrange with a TempStars office.
        <br/><br/>
        Many members make lasting connections with TempStars client offices. If an office asks you to come back for another shift, awesome! Just be sure to follow our policy for direct bookings by recording it using this button. This ensures you are protected by our policies, allows you to easily invoice, and keep track of your schedule!
        <br/>
        <a href="#" onClick={(e) => { e.preventDefault(); const url = 'https://support.tempstars.com/hc/en-us/articles/1500008821802-Report-Book-A-Shift-'; try { if ((window as any).Cordova) { (window as any).cordova.InAppBrowser.open(url, '_system', 'location=yes'); } else { window.open(url, '_blank', 'location=yes'); } } catch {} }}>Click here to learn more!</a>
      </div>
      <div className={styles.actions}>
        <button type="button" className={styles.primaryButton} onClick={onClose} aria-label="I understand" data-testid="manual-shift-info-understand">I understand</button>
      </div>
    </div>
  </PlainModal>
)


